import { RegisterContainer } from "../../containers/RegisterSystem/RegisterContainer";

export function CompanyRegisterPage() {
    return (
        <RegisterContainer />
    )
}